import NumberFormat from "react-number-format"
import { GetCityWithSection } from "hooks/returnCityName"
import { Button, Tag, Tooltip, Space, Avatar } from "antd"
import {
  EditOutlined,
  IdcardOutlined,
  PhoneOutlined,
  BankOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons"
import InactiveExecutor from "./InactiveExecutor"
import { UserFiles } from "./user-files"

const renderEditButton = (record, { handleEdit }) => (
  <Tooltip title="ویرایش">
    <Button
      type="primary"
      ghost
      size="small"
      icon={<EditOutlined />}
      onClick={() => handleEdit(record)}
      style={{ borderRadius: "6px" }}
    />
  </Tooltip>
)

const renderInactiveButton = (record, { props }) => (
  <Tooltip title={record.inactive ? "فعال سازی" : "غیرفعالسازی"}>
    <InactiveExecutor rowData={record} mainProps={props} />
  </Tooltip>
)

const renderFilesButton = (record, { props }) => (
  <Tooltip title="فایل ها">
    <div>
      <UserFiles rowData={record} mainProps={props} />
    </div>
  </Tooltip>
)

const formatBalance = value => (
  <NumberFormat displayType="text" value={value} thousandSeparator />
)

const cityText = row => {
  if (row.idSection > 0) return GetCityWithSection(row.idSection)
  return "-"
}

export const columns = ({ props, handleEdit }) => [
  {
    title: "عملیات",
    key: "actions",
    width: 140,
    fixed: "left",
    align: "center",
    render: record => (
      <Space size={6}>
        {renderEditButton(record, { handleEdit })}
        {renderInactiveButton(record, { props })}
        {renderFilesButton(record, { props })}
      </Space>
    ),
  },
  {
    title: "مجری",
    dataIndex: "fullName",
    key: "fullName",
    width: 200,
    ellipsis: {
      showTitle: false,
    },
    render: (text, record) => (
      <Space>
        <Avatar
          style={{ backgroundColor: "#1890ff", fontWeight: 600 }}
        >
          {text?.charAt(0) || "؟"}
        </Avatar>
        <div>
          <Tooltip title={text || "-"}>
            <div style={{ fontWeight: 600 }}>{text || "بدون نام"}</div>
          </Tooltip>
          <Tag icon={<IdcardOutlined />} color="blue" style={{ marginTop: 4 }}>
            {record.naCode || "-"}
          </Tag>
        </div>
      </Space>
    ),
  },
  {
    title: "کاربری / موبایل",
    key: "userPhone",
    width: 100,
    render: record => (
      <Space direction="vertical" size={4}>
        <Tag color="purple">{record.userName || "-"}</Tag>
        <Tag icon={<PhoneOutlined />} color="green">
          {record.cellPhone || "-"}
        </Tag>
      </Space>
    ),
  },
  {
    title: "موجودی",
    dataIndex: "balance",
    key: "balance",
    width: 120,
    align: "center",
    render: value => (
      <Tag color="gold" style={{ minWidth: 90, textAlign: "center" }}>
        {formatBalance(value)}
      </Tag>
    ),
  },
  {
    title: "عضویت / اعتبار",
    key: "dates",
    width: 100,
    render: record => (
      <Space direction="vertical" size={4}>
        <Tag color="processing" icon={<BankOutlined />}>
          {record.solarMembershipDate || "-"}
        </Tag>
        <Tag color="default">{record.solarLicenseExpire || "-"}</Tag>
      </Space>
    ),
  },
  {
    title: "اعتبار پروانه",
    key: "licenseValidity",
    width: 100,
    align: "center",
    render: record => (
      <Tag color={record.expiredDateLicense ? "red" : "green"}>
        {record.expiredDateLicense ? "منقضی" : "معتبر"}
      </Tag>
    ),
  },
  {
    title: "شهر",
    key: "city",
    width: 100,
    render: row => (
      <Tag icon={<EnvironmentOutlined />} color="orange">
        {cityText(row)}
      </Tag>
    ),
  },
  {
    title: "وضعیت",
    key: "inactiveStatus",
    width: 100,
    align: "center",
    render: record => (
      <Tooltip title={record.inactive ? record.inactiveDes || "بدون توضیح" : "فعال"}>
        <Tag color={record.inactive ? "red" : "green"}>
          {record.inactive ? "غیرفعال" : "فعال"}
        </Tag>
      </Tooltip>
    ),
  },
]
